// import React, { useState } from 'react';
// import axios from '../backendService';

// const Notification = () => {
//     const [title, setTitle] = useState('');
//     const [message, setMessage] = useState('');

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         try {
//             const response = await axios.post('notification/all', { title, message });
//             console.log('Response:', response.data);
//             alert('Notifications sent successfully.');
//         } catch (error) {
//             console.error('Error sending notifications:', error);
//             alert('Failed to send notifications.');
//         }
//     };

//     return (
//         <div>
//             <h2>Send Notification to All Users</h2>
//             <form onSubmit={handleSubmit}>
//                 <div>
//                     <label>Title:</label>
//                     <input
//                         type="text"
//                         value={title}
//                         onChange={e => setTitle(e.target.value)}
//                         required
//                     />
//                 </div>
//                 <div>
//                     <label>Message:</label>
//                     <textarea
//                         value={message}
//                         onChange={e => setMessage(e.target.value)}
//                         required
//                     ></textarea>
//                 </div>
//                 <button type="submit">Send</button>
//             </form>
//         </div>
//     );
// };

// export default Notification;

// import React from 'react';
// import { Row, Col, Form, Input, Button } from 'antd';

// function Notification() {
//   const [title, setTitle] = useState('');
//   const [message, setMessage] = useState('');

//   const onFinish = async (values) => {
//     try {
//       const response = await axios.post('notification/all', values);
//       console.log('Response:', response.data);
//       alert('Notifications sent successfully.');
//     } catch (error) {
//       console.error('Error sending notifications:', error);
//       alert('Failed to send notifications.');
//     }
//   };
//   return (
//     <div className="bg-white dark:bg-white10 m-0 p-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative h-full">
// <div className="h-[60px] px-[25px] text-dark dark:text-white87 font-medium text-[17px] border-regular dark:border-white10 border-b">
//   <h1 className="mb-0 inline-block py-[16px] overflow-hidden whitespace-nowrap text-ellipsis text-[18px] font-semibold">
//     Custom Notification Form
//   </h1>
// </div>
//       <div className="p-[25px]">
//         <Form name="horizontal-form" layout="horizontal" onFinish={onFinish}>
//           <Row align="middle">
//             <Col lg={8} md={9} xs={24}>
//               <label className="font-medium mb-[24px] block dark:text-white60" htmlFor="name">
//                 Title
//               </label>
//             </Col>
//             <Col lg={16} md={15} xs={24}>
//               <Form.Item name="name" >
//                 <Input placeholder="Enter Title" />
//               </Form.Item>
//             </Col>
//           </Row>
//           <Row align="middle">
//             <Col lg={8} md={9} xs={24}>
//               <label className="font-medium mb-[24px] block dark:text-white60" htmlFor="message">
//                 Message
//               </label>
//             </Col>
//             <Col lg={16} md={15} xs={24}>
//               <Form.Item name="message" >
//                 <Input placeholder="Enter Message" />
//               </Form.Item>
//             </Col>
//           </Row>
//           <Row>
//             <Col lg={{ span: 16, offset: 8 }} md={{ span: 15, offset: 9 }} xs={{ span: 24, offset: 0 }}>
//               <div className="flex flex-wrap gap-[15px]">
//                 <Button
//                   className="bg-primary hover:bg-hbr-primary border-solid border-1 border-primary text-white dark:text-white87 text-[14px] font-semibold leading-[22px] inline-flex items-center justify-center rounded-[4px] px-[20px] h-[44px]"
//                   type="primary"
//                   size="large"
//                   htmlType="submit"
//                 >
//                   Send
//                 </Button>
//               </div>
//             </Col>
//           </Row>
//         </Form>
//       </div>
//     </div>
//   );
// }

// export default Notification;

import React, { useState } from 'react';
import axios from '../backendService';
import { Row, Col, Form, Input, Button, message as antMessage, PageHeader } from 'antd';

function Notification() {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      const response = await axios.post('notification/all', values);
      // console.log('Response:', response.data);
      antMessage.success('Notifications sent successfully.');
      form.resetFields(); // Reset form fields after submission
    } catch (error) {
      console.error('Error sending notifications:', error);
      antMessage.error('Failed to send notifications.');
    }
  };

  return (
    <>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        title="  "
      />

      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent mx-20">
        <Row gutter={35} justify="center">
          <Col xs={20}>
            <>
              <div className="bg-white dark:bg-white10 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px] mx-20">
                <div className="dark:bg-white10 m-0 p-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative h-full">
                  <div className="h-[60px] px-[25px] text-dark dark:text-white87 font-medium text-[17px] border-regular dark:border-white10 border-b">
                    <h1 className="mb-0 inline-block py-[16px] overflow-hidden whitespace-nowrap text-ellipsis text-[18px] font-semibold">
                      Broadcast Notification Form
                    </h1>
                  </div>
                  <div className="p-[25px]">
                    <Form name="horizontal-form" layout="horizontal" onFinish={handleSubmit} form={form}>
                      <Row align="middle">
                        <Col lg={8} md={9} xs={24}>
                          <label className="font-medium mb-[24px] block dark:text-white60">Title</label>
                        </Col>
                        <Col lg={16} md={15} xs={24}>
                          <Form.Item name="title" rules={[{ required: true, message: 'Please input a title!' }]}>
                            <Input placeholder="Enter Notification Title" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row align="middle">
                        <Col lg={8} md={9} xs={24}>
                          <label className="font-medium mb-[24px] block dark:text-white60">Message</label>
                        </Col>
                        <Col lg={16} md={15} xs={24}>
                          <Form.Item name="message" rules={[{ required: true, message: 'Please input a message!' }]}>
                            <Input.TextArea rows={4} placeholder="Type Your Notification Message Here" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={{ span: 16, offset: 8 }} md={{ span: 15, offset: 9 }} xs={{ span: 24, offset: 0 }}>
                          <div className="flex flex-wrap gap-[15px]">
                            <Button
                              className="bg-primary hover:bg-hbr-primary border-solid border-1 border-primary text-white dark:text-white87 text-[14px] font-semibold leading-[22px] inline-flex items-center justify-center rounded-[4px] px-[20px] h-[44px]"
                              type="primary"
                              size="large"
                              htmlType="submit"
                            >
                              Send to all
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </>
          </Col>
        </Row>
      </main>
    </>
  );
}

export default Notification;
